(() => {
  const trigger = document.getElementById('tdHomeMenuTrigger');
  const menu = document.getElementById('tdHomeMobileMenu');
  if (!trigger || !menu) return;
  const englishMenu = trigger.getAttribute('aria-label') === 'Open menu';
  let previousFocus = null;
  let pointerActivation = false;
  trigger.addEventListener('pointerdown', () => { pointerActivation = true; });
  const focusables = () => [trigger,...menu.querySelectorAll('a[href],button:not([disabled])')];
  function openMenu() {
    previousFocus = document.activeElement;
    menu.hidden = false;
    menu.setAttribute('aria-hidden','false');
    trigger.setAttribute('aria-expanded','true');
    trigger.setAttribute('aria-label',englishMenu ? 'Close menu' : 'Cerrar menú');
    document.body.classList.add('td-home-menu-open');
    /* Keyboard retains its focus indicator; touch/click focus is cleared after activation. */
  }
  function closeMenu() {
    menu.hidden = true;
    menu.setAttribute('aria-hidden','true');
    trigger.setAttribute('aria-expanded','false');
    trigger.setAttribute('aria-label',englishMenu ? 'Open menu' : 'Abrir menú');
    document.body.classList.remove('td-home-menu-open');
    const destination = previousFocus instanceof HTMLElement ? previousFocus : trigger;
    destination.focus({preventScroll:true});
    previousFocus = null;
  }
  trigger.addEventListener('click', () => {
    const fromPointer = pointerActivation;
    pointerActivation = false;
    if (menu.hidden) openMenu();
    else closeMenu();
    if (fromPointer && document.activeElement === trigger) trigger.blur();
  });
  menu.addEventListener('click',event => {
    if(event.target.closest('a'))closeMenu();
  });
  document.addEventListener('keydown',event => {
    if(menu.hidden)return;
    if(event.key==='Escape'){event.preventDefault();closeMenu();return;}
    if(event.key!=='Tab')return;
    const els=focusables();
    const i=els.indexOf(document.activeElement);
    const next=event.shiftKey ? (i<=0?els.length-1:i-1) : (i<0||i===els.length-1?0:i+1);
    event.preventDefault();
    els[next]?.focus({preventScroll:true});
  });
  const mq=window.matchMedia('(min-width:721px)');
  const onSize=e=>{if(e.matches&&!menu.hidden)closeMenu();};
  mq.addEventListener?.('change',onSize);
})();